import { Injectable } from "@angular/core";
import { HttpService } from "../http.service";

@Injectable({
  providedIn: "root",
})
export class OrtakTanimlarService {
  constructor(private http: HttpService) {}

  // Bulgu 3.1.12: TCKimlikNo/AdSoyad/Sicil URL yerine istek gövdesi ile gönderilir.
  kurumProvizyonListesi(talepTurId) {
    return this.http.httpPost(`OrtakTanimlar/KurumProvizyonListesi`, {
      TalepTurTanimID: talepTurId,
    });
  }

  kurumProvizyonListesiHastaTuru(talepTurId, hastaTuru) {
    return this.http.httpPost(`OrtakTanimlar/KurumProvizyonListesi`, {
      TalepTurTanimID: talepTurId,
      HastaTuru: hastaTuru,
    });
  }

  kurumProvizyonListesiYatisDurumId(hastaTuru, yatisDurumId) {
    return this.http.httpPost(`OrtakTanimlar/KurumProvizyonListesi`, {
      TalepTurTanimID: 5,
      HastaTuru: hastaTuru,
      ProvizyonYatisDurumID: yatisDurumId,
    });
  }
  kurumProvizyonListesiHepsiYatisDurumId(yatisDurumId) {
    return this.http.httpPost(`OrtakTanimlar/KurumProvizyonListesi`, {
      TalepTurTanimID: 5,
      ProvizyonYatisDurumID: yatisDurumId,
    });
  }
  kurumProvizyonListesiHepsiDisDurumId(disDurumId) {
    return this.http.httpPost(`OrtakTanimlar/KurumProvizyonListesi`, {
      TalepTurTanimID: 3,
      ProvizyonDisDurumID: disDurumId,
    });
  }

  kurumProvizyonListesiTc(talepTurId, tc) {
    return this.http.httpPost(`OrtakTanimlar/KurumProvizyonListesi`, {
      TalepTurTanimID: talepTurId,
      TCKimlikNo: tc,
    });
  }

  kurumProvizyonListesiFaturaSahibi(talepTurId, faturaSahibi) {
    return this.http.httpPost(`OrtakTanimlar/KurumProvizyonListesi`, {
      TalepTurTanimID: talepTurId,
      FaturaSahibiAdSoyad: faturaSahibi,
    });
  }
  kurumProvizyonListesiProvizyonNo(talepTurId, provizyonNo) {
    return this.http.httpPost(`OrtakTanimlar/KurumProvizyonListesi`, {
      TalepTurTanimID: talepTurId,
      ProvizyonID: provizyonNo,
    });
  }
  bransListesiVakifDis() {
    return this.http.httpGet(
      `OrtakTanimlar/BransListesiVakif?Ad=Di%C5%9F%20Hekimli%C4%9F`
    );
  }
  bransListesiShyDis() {
    return this.http.httpGet(
      `OrtakTanimlar/BransListesiVakif?Ad=Di%C5%9F%20Hekimli%C4%9F`
    );
  }
  bransListesiVakif() {
    return this.http.httpGet("OrtakTanimlar/BransListesiVakif");
  }

  islemTipListesi() {
    return this.http.httpGet(
      "OrtakTanimlar/IslemTipTanimListesi?TalepTurTanimID=5"
    );
  }

  bransListesiShy(tarih) {
    return this.http.httpGet(`OrtakTanimlar/BransListesiShy/${tarih}`);
  }

  icd10TanimGetir(id) {
    return this.http.httpGet(`OrtakTanimlar/ICD10TanimGetir/${id}`);
  }

  icd10TanimListesi(kodAd) {
    return this.http.httpGet(`OrtakTanimlar/ICD10TanimListesi?kodAd=${kodAd}`);
  }

  kurumAyaktaTedaviTeminatListesi(tarih) {
    return this.http.httpGet(
      `OrtakTanimlar/KurumAyaktaTedaviTeminatListesi/${tarih}`
    );
  }

  kurumSeansliIslemTeminatListesi(tarih) {
    return this.http.httpGet(
      `OrtakTanimlar/KurumSeansliIslemTeminatListesi/${tarih}`
    );
  }

  // odenenFaturaListesi() {
  //   return this.http.httpGet(`OrtakTanimlar/OdenenFaturaListesi?HastaTCNo=1&HastaAdSoyad=1&ProvizyonNo=1&FaturaNo=1&OdemeTarihiBas=1&OdemeTarihBit=1&SiralamaTuru=1`)
  // }
  // Bulgu 3.1.12: HastaTCNo/HastaAdSoyad/Sicil URL yerine istek gövdesi ile gönderilir.
  odenenFaturaListesi() {
    return this.http.httpPost("OrtakTanimlar/OdenenFaturaListesi", {});
  }

  odenenFaturaListesiProvizyonNo(provizyonNo) {
    return this.http.httpPost(`OrtakTanimlar/OdenenFaturaListesi`, {
      ProvizyonNo: provizyonNo,
    });
  }
  odenenFaturaListesiTc(tc) {
    return this.http.httpPost(`OrtakTanimlar/OdenenFaturaListesi`, {
      HastaTCNo: tc,
    });
  }
  odenenFaturaListesiFaturaNo(faturaNo) {
    return this.http.httpPost(`OrtakTanimlar/OdenenFaturaListesi`, {
      FaturaNo: faturaNo,
    });
  }
  odenenFaturaListesiAdSoyad(adSoyad) {
    return this.http.httpPost(`OrtakTanimlar/OdenenFaturaListesi`, {
      HastaAdSoyad: adSoyad,
    });
  }
  odenenFaturaListesiPaketNo(paketNo) {
    return this.http.httpPost(`OrtakTanimlar/OdenenFaturaListesi`, {
      ProvizyonNo: paketNo,
    });
  }
  odenenFaturaListesiOdemeTarihiBaslangic(baslangicTarihi) {
    return this.http.httpPost(`OrtakTanimlar/OdenenFaturaListesi`, {
      OdemeTarihiBas: baslangicTarihi,
    });
  }
  odenenFaturaListesiOdemeTarihiBitis(bitisTarihi) {
    return this.http.httpPost(`OrtakTanimlar/OdenenFaturaListesi`, {
      OdemeTarihBit: bitisTarihi,
    });
  }
  odenenFaturaListesiOdemeSira(sira) {
    return this.http.httpPost(`OrtakTanimlar/OdenenFaturaListesi`, {
      SiralamaTuru: sira,
    });
  }
  odenenFaturaListesiOdemeBaslangicBitis(baslangic, bitis) {
    return this.http.httpPost(`OrtakTanimlar/OdenenFaturaListesi`, {
      OdemeTarihiBas: baslangic,
      OdemeTarihBit: bitis,
    });
  }
  odenenFaturaListesiHepsi(
    hastaTuru = "",
    sicil = "",
    hastaTCNo = "",
    adSoyad = "",
    faturaDurumTanimId = "",
    provizyonNo = "",
    faturaNo = "",
    provizyonPaketID = "",
    basTarih = "",
    bitTarih = "",
    siralamaTuru = 0
  ) {
    return this.http.httpPost(
      `OrtakTanimlar/OdenenFaturaListesi`,
      this.bosAlanlariTemizle({
        HastaTuru: hastaTuru,
        Sicil: sicil,
        HastaTCNo: hastaTCNo,
        HastaAdSoyad: adSoyad,
        FaturaDurumTanimID: faturaDurumTanimId,
        ProvizyonNo: provizyonNo,
        FaturaNo: faturaNo,
        ProvizyonPaketID: provizyonPaketID,
        OdemeTarihiBas: basTarih,
        OdemeTarihBit: bitTarih,
        SiralamaTuru: siralamaTuru,
      })
    );
  }
  // odenenFaturaListesiProvizyonNo(provizyonNo){
  //   return this.http.httpGet(`OrtakTanimlar/OdenenFaturaListesi?ProvizyonNo=${provizyonNo}`)
  // }

  //----------

  // odenenFaturaListesi(){
  //   return this.http.httpGet(`OrtakTanimlar/OdenenFaturaListesi`)
  // }
  // odenenFaturaListesi(){
  //   return this.http.httpGet(`OrtakTanimlar/OdenenFaturaListesi`)
  // }
  // odenenFaturaListesi(){
  //   return this.http.httpGet(`OrtakTanimlar/OdenenFaturaListesi`)
  // }
  // odenenFaturaListesi(){
  //   return this.http.httpGet(`OrtakTanimlar/OdenenFaturaListesi`)
  // }
  // odenenFaturaListesi(){
  //   return this.http.httpGet(`OrtakTanimlar/OdenenFaturaListesi`)
  // }
  // odenenFaturaListesi(){
  //   return this.http.httpGet(`OrtakTanimlar/OdenenFaturaListesi`)
  // }

  tevkifatKdvOraniGetir(tarih, provizyonFaturaDurumTanimID: number) {
    return this.http.httpGet(
      `OrtakTanimlar/TevkifatGrupOranlarGetir/${tarih}?provizyonFaturaDurumTanimID=${provizyonFaturaDurumTanimID}`
    );
  }

  // Bulgu 3.1.12: provizyonFaturaDurumTanimID/HastaTuru URL yerine istek gövdesi ile gönderilir.
  kontrolBekleyenProvizyonListesi(value) {
    return this.http.httpPost(`OrtakTanimlar/KontrolBekleyenProvizyonListesi`, {
      ProvizyonFaturaDurumTanimID: value,
    });
  }

  kontrolBekleyenProvizyonListesiId(value, hastaTuru) {
    return this.http.httpPost(`OrtakTanimlar/KontrolBekleyenProvizyonListesi`, {
      HastaTuru: hastaTuru,
      ProvizyonFaturaDurumTanimID: value,
    });
  }

  kontrolBekleyenProvizyonListesiPaketDurumId(paketDurumId) {
    return this.http.httpPost(`OrtakTanimlar/KontrolBekleyenProvizyonListesi`, {
      ProvizyonFaturaDurumTanimID: paketDurumId,
    });
  }
  // Bulgu 3.1.12: TCKimlikNo/AdSoyad URL yerine istek gövdesi ile gönderilir.
  dosyaYuklemeProvizyonListesi(
    faturaSahibiAdSoyad,
    TCKimlikNo,
    provizyonId,
    hizmetTarihBas,
    hizmetTarihBit
  ) {
    return this.http.httpPost(
      `OrtakTanimlar/DosyaYuklemeProvizyonListesi`,
      this.bosAlanlariTemizle({
        FaturaSahibiAdSoyad: faturaSahibiAdSoyad,
        TCKimlikNo: TCKimlikNo,
        ProvizyonID: provizyonId,
        HizmetTarihBas: hizmetTarihBas,
        HizmetTarihBit: hizmetTarihBit,
      })
    );
  }

  dosyaYuklemeProvizyonListesiHastaTuru(
    hastaTuru,
    faturaSahibiAdSoyad,
    TCKimlikNo,
    provizyonId,
    hizmetTarihBas,
    hizmetTarihBit
  ) {
    return this.http.httpPost(
      `OrtakTanimlar/DosyaYuklemeProvizyonListesi`,
      this.bosAlanlariTemizle({
        HastaTuru: hastaTuru,
        FaturaSahibiAdSoyad: faturaSahibiAdSoyad,
        TCKimlikNo: TCKimlikNo,
        ProvizyonID: provizyonId,
        HizmetTarihBas: hizmetTarihBas,
        HizmetTarihBit: hizmetTarihBit,
      })
    );
  }

  // Bulgu 3.1.12: Liste filtreleri JSON body ile gönderildiğinden, boş ("") / null
  // alanlar gövdeden çıkarılır; böylece backend'de int?/DateTime? alanlar null olur
  // ve boş string bağlama hatası oluşmaz.
  private bosAlanlariTemizle(obj: any) {
    const sonuc: any = {};
    Object.keys(obj).forEach((anahtar) => {
      const deger = obj[anahtar];
      if (deger !== null && deger !== undefined && deger !== "") {
        sonuc[anahtar] = deger;
      }
    });
    return sonuc;
  }
}
